export default defineNuxtRouteMiddleware((to) => {
  const { isLoggedIn } = useCustomerStore()

  if (!isLoggedIn) {
    return navigateTo({
      path: useLocalePath()('/'),
      query: { auth: 'login', redirect: to.fullPath },
    })
  }
})
